import React, {useEffect, useState} from "react";
import Loading from "./Loading";
import {Text} from "./styles";
import {
    getMemberCountFromConversation,
    getOtherUserDuoConversation
} from "./utils";

type Props = {
    conversation: any;
    kind: string;
};

const ChannelSubtitle: React.FC<Props> = ({conversation, kind}) => {
    const [state, setState] = useState({loading: kind !== 'Bot', memberCount: 0, title: "Delivery Associate"});
    const {loading, memberCount, title} = state;

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on("participantLeft", () => {
                setState(currState => ({...currState, memberCount: currState.memberCount - 1}));
            });
            conversation.on("participantJoined", () => {
                setState(currState => ({...currState, memberCount: currState.memberCount + 1}));
            });
            if (kind === "Duo") {
                getOtherUserDuoConversation(conversation).then(user => {
                    if (user && user.attributes) {
                        if (user.attributes["title"]) {
                            // @ts-ignore
                            setState(currState => ({...currState, title: user.attributes["title"], loading: false}));
                        } else if (user.attributes["role"]) {
                            // @ts-ignore
                            setState(currState => ({...currState, title: user.attributes["role"], loading: false}));
                        }
                    }
                });
            } else if (kind === "Group") {
                getMemberCountFromConversation(conversation).then(number => {
                    setState(currState => ({...currState, memberCount: number, loading: false}));
                })
            }
        }
        return () => {
            if (conversation) {
                conversation.removeAllListeners();
            }
            abortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return <Loading imgHeight={"12px"} containerHeight={"14px"}/>;
    }

    if (kind === "Bot") {
        return (
            <Text color="#707070" fontSize="12px" lineHeight="12px" height="14px">
                Your Work Assistant
            </Text>
        );
    }

    if (title && kind === "Duo") {
        return (
            <div style={{display: "flex", columnGap: "2px"}}>
                <Text color="#707070" fontSize="12px" lineHeight="normal" height="unset">{title}</Text>
            </div>
        );
    }

    return (
        <Text
            color="#707070"
            fontSize="12px"
            lineHeight="12px"
            height="14px"
        >{`${kind} - ${memberCount} members`}</Text>
    );
}

function propsAreEqual(prev, next) {
    return prev.conversation.sid === next.conversation.sid;
}

const MemoizedChannelSubtitle = React.memo(ChannelSubtitle, propsAreEqual);
// export default ChannelSubtitle;
export default MemoizedChannelSubtitle;
